export default __webpack_public_path__ + "static/icon-box-search-aa9927d36551e23c391c9b18ddaf9ca3.svg";